import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const Containers = () => import('./pages');

const moduleRoute = {
  path: 'master-data/containers',
  name: 'Containers',
  component: Containers,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.PRODUCTS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
